import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export interface SoftButtonProps extends Omit<TouchableProps, 'haptic'> {
  size?: 'md' | 'lg';
}

const BASE_MD =
  'w-full py-3 rounded-2xl bg-soft text-ink-muted font-bold active:scale-[0.98] transition-all';

const BASE_LG =
  'flex items-center justify-center gap-2 h-20 bg-soft text-ink-muted rounded-3xl active:scale-[0.97] active:bg-line transition-all touch-manipulation focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2';

export const SoftButton: React.FC<SoftButtonProps> = ({ size = 'md', className, ...rest }) => {
  const base = size === 'lg' ? BASE_LG : BASE_MD;
  return (
    <Touchable haptic="softTap" className={className ? `${base} ${className}` : base} {...rest} />
  );
};
